module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/babel-runtime/core-js/array/from.js
// module id = 736
// module chunks = 1 2 3 5 6 7 9 10 13 22 23